// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const MOE = {
  BRL: 'MOE1',
  USD: 'MOE2',
  EUR: 'MOE3',
  GBP: 'MOE4',
  CNY: 'MOE5',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    MOE1: 1,
    MOE2: 2,
    MOE3: 3,
    MOE4: 4,
    MOE5: 5
  }
}
